export default "__VITE_ASSET__WKV9gUNv__"